import React from 'react';
import { useDeleteClinicMasterProduct } from '../../../../apis/clinic-master-products/hooks/useDeleteClinicMasterProduct';
import { DangerButton } from '../../../../healtheraComponents';
import { useHistory } from 'react-router';
import { enqueueSnackbar } from 'notistack';

interface DeleteClinicMasterProductProps {
  id: string;
  clinicId: string;
}

const DeleteClinicMasterProduct = ({ clinicId, id }: DeleteClinicMasterProductProps) => {
  const { deleteClinicMasterProduct, isLoading } = useDeleteClinicMasterProduct();
  const history = useHistory();

  const handleDelete = async () => {
    const shouldDelete = window.confirm('Are you sure you want to delete this clinic\'s master product?');

    if (shouldDelete) {
      await deleteClinicMasterProduct(id);
      enqueueSnackbar('Clinic master product deleted', { variant: 'success' });
      history.replace(`/clinics/${clinicId}/products`);
    }
  };

  return (
    <DangerButton disabled={isLoading} onClick={handleDelete}>
      Delete
    </DangerButton>
  );
};

export default DeleteClinicMasterProduct;
